import * as React from 'react';
import {useCookies} from 'react-cookie';
import LocationsIndex, {Props} from './LocationsIndex';

const LocationsIndexWithCookies: React.FC<Props> = (props) => {
  const [cookies] = useCookies(['selected_warehouse_id']);
  return <LocationsIndex {...props} selectedWarehouseId={parseInt(cookies.selected_warehouse_id, 10)} />;
};

export default LocationsIndexWithCookies;
